import { observable } from "mobx";
import { Type } from "class-transformer";
import OpeningHoursResponse from "./openingHoursResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SalespointResponse {
  /**
   * Contact phone.
   */
  @observable
  contactPhone?: string;

  /**
   * Salespoint address.
   */
  @observable
  address?: string;

  /**
   * Salespoint postal code.
   */
  @observable
  postalCode?: string;

  /**
   * Indicates whether card payment is allowed.
   */
  @observable
  cardPaymentAllowed!: boolean;

  /**
   * External detail link in Czech.
   */
  @observable
  externalDetailLinkCs?: string;

  /**
   * External detail link in English.
   */
  @observable
  externalDetailLinkEn?: string;

  /**
   * The list of opening hours.
   */
  @observable
  @Type(() => OpeningHoursResponse)
  openingHours!: OpeningHoursResponse[];
}
